import { loggingService } from "../../../services/loggingService";

/**
 * @param {string} text
 * @param {(ok: boolean) => void} [onDone]
 */
export async function copyActivationText(text, onDone) {
  try {
    await navigator.clipboard.writeText(text);
    onDone?.(true);
  } catch (e) {
    loggingService.error("activation clipboard copy failed", { error: e });
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      onDone?.(true);
    } catch (e2) {
      loggingService.error("activation clipboard fallback failed", { error: e2 });
      onDone?.(false);
    }
  }
}
